import React from 'react';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import { forEach, get, isArray } from 'lodash';

import { capitalizeFirstLetter } from '@lib/services/stringsService';

import usePermissions from 'hooks/usePermissions';

import Typography from './Typography';

const styles = ({
  custom: {
    palette: { colorSupportMidnight },
  },
}: Theme) =>
  createStyles({
    links: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      cursor: 'pointer',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: `underline ${colorSupportMidnight}`,
      },
    },
  });

export enum ResourceTypesEnum {
  AppointmentType = 'appointmentType',
  Provider = 'provider',
  Facility = 'facility',
}

interface LinkResourcesProps extends WithStyles<typeof styles> {
  text: string;
  type: ResourceTypesEnum;
  id: string | string[];
  stopPropagation?: boolean;
}

function handleRouteType(type: ResourceTypesEnum) {
  if (type === ResourceTypesEnum.Facility) return 'facilities';
  if (type === ResourceTypesEnum.Provider) return 'providers';
  if (type === ResourceTypesEnum.AppointmentType) return 'appointment-types';
  return '';
}

const LinkResources: React.FC<LinkResourcesProps> = ({ text, type, id, classes, stopPropagation }) => {
  const { permissions } = usePermissions();

  const isAuthorized = get(permissions, 'isAdmin') || get(permissions, 'isManager');

  const routeType = handleRouteType(type);

  if (!isAuthorized || text === 'Any' || !routeType) return capitalizeFirstLetter(text);

  const routeBase = '/v2/settings/practice-resources';

  if (isArray(id)) {
    return (
      <Typography
        className={classes.links}
        data-lh-id={`link-${type}`}
        onClick={(event) => {
          if (stopPropagation) event.stopPropagation();
          forEach(id, (specificId) => window.open(`${routeBase}/${routeType}/${specificId}`));
        }}
      >
        {capitalizeFirstLetter(text)}
      </Typography>
    );
  }

  return (
    <Typography
      to={`${routeBase}/${routeType}/${id}`}
      shouldOpenInANewTab
      data-lh-id={`link-${type}`}
      onClick={(event) => {
        if (stopPropagation) event.stopPropagation();
      }}
    >
      {capitalizeFirstLetter(text)}
    </Typography>
  );
};

export default withStyles(styles)(LinkResources);
